export const trimContentToMaxChars = (html, maxChars) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  let currentLength = 0;
  const trimNode = (node) => {
    if (currentLength >= maxChars) {
      node.remove();
      return;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const remainingChars = maxChars - currentLength;
      if (node.textContent.length > remainingChars) {
        node.textContent = node.textContent.substring(0, remainingChars);
        currentLength = maxChars;
      } else {
        currentLength += node.textContent.length;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      for (let i = node.childNodes.length - 1; i >= 0; i--) {
        trimNode(node.childNodes[i]);
      }
    }
  };

  trimNode(tempDiv);
  return tempDiv.innerHTML;
};
